<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header></Header>
    <b-container fluid>

      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Dental</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>IC_01_intercosulta</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          Bandeja de interconsulta
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <BandejaInterconsulta></BandejaInterconsulta>
        </b-col>
      </b-row>
    </b-container>

  </div>

</template>

<script>
import Header from "@/components/Header";
import BandejaInterconsulta from "@/components/Interconsulta/BandejaInterconsulta";
export default {
name: "BandejaInterConsultaFull",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  components: {Header, BandejaInterconsulta}
}
</script>

<style scoped>

</style>
